import { Document } from '@contentful/rich-text-types'
import { TopLevelBlock } from '@contentful/rich-text-types'
import { Asset } from 'contentful'
import { ResponsiveImage } from '~/components/ResponsiveImage'
import { RichText } from '~/components/RichText'

type InfoWidgetProps = {
  entry: TopLevelBlock
}

type DataProps = {
  title: string
  backgroundColour: string
  titleColor: string
  body: Document
  icon: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export default function InfoWidget({ entry }: InfoWidgetProps) {
  const { backgroundColour, icon, title, titleColor, body } = (entry?.data?.target?.fields ||
    {}) as DataProps
  return (
    <div
      className="flex flex-col gap-5 rounded-3xl pt-2 px-6 pb-8"
      style={{ backgroundColor: backgroundColour }}
    >
      <div className="flex gap-2 items-center border-indigo-20 py-5">
        <div className="w-5 h-5">
          <ResponsiveImage asset={icon?.fields} />
        </div>
        <h2 className="text-s" style={{ color: titleColor }}>
          {title}
        </h2>
      </div>
      {body.content.map((content: TopLevelBlock, idx: number) => (
        <RichText key={idx} doc={content as unknown as Document} />
      ))}
    </div>
  )
}
